import * as React from 'react';
import { Hr, Paragraph } from '../../../../elements';
import NotationButton from '../../../../notation-button/NotationButton';
import TwoColRow from './TwoColRow';
const PropertyOwnershipRow = ({ value, i18n, formatDate }) => {
    const propertiesToUse = [
        'unitDesignation',
        'type',
        'ownershipPercentage',
        'numberOfOwner',
        'totalArea',
        'county',
        'municipality'
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement(Hr, null),
            value.properties.map((property, index) => {
                return (React.createElement("div", null,
                    React.createElement("br", null),
                    Object.keys(property)
                        .filter(keys => propertiesToUse.includes(keys))
                        .map(key => {
                        return (React.createElement(TwoColRow, { label: i18n(`controlpoint.propertyOwnership.${key}`), value: property[key] }));
                    })));
            })),
        React.createElement(Hr, null),
        React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.property')} (${formatDate(value.verificationDate)})` }),
        value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--medium' },
            React.createElement(Paragraph, { bold: true },
                i18n('common.note'),
                " ",
                React.createElement(NotationButton, { small: true })),
            React.createElement("div", { className: 'ReadReportContent__NotationContent' },
                React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
};
export default PropertyOwnershipRow;
